import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  cardPendingStatus: "idle",
  cardAssignedStatus: "idle",
  cardData: {
    Pending: [],
    Assigned: [],
  },
  tableFields: {},
  formData: [],
  showFilter: false,
  showTable: false,
  search: "",
  assignedSearch: "",
  pendingSearch: "",
  gliData: {
    name: "",
    id: "",
    shop: "",
  },
  from_date: "",
  to_date: "",
  item_type: [],
  shop: [],
  status: [],
  date: [],
  certificateData: [],
  showAssignedTable: false,
  curretPageSize: 10,
  currentPage: 1,
  PendingTotal: "",
  AssignedTotal: "",
  currentPageTab:1
};

export const getCardPendingList = createAsyncThunk(
  "card/pending-list",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/order/pending-queue`,
        params
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCardAssignedList = createAsyncThunk(
  "card/assigned-list",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/order/assigned-to-me`,
        params
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: () => initialState,
  },
  extraReducers: (builder) => {
    // pending list
    builder.addCase(getCardPendingList.pending, (state) => {
      state.cardPendingStatus = "pending";
    });
    builder.addCase(getCardPendingList.fulfilled, (state, action) => {
  state.cardPendingStatus = "fulfilled";

  const newData = action.payload.data.data.data;
  const totalCount = action.payload.data.data.total_count;

  const existingPending = state.cardData?.Pending || [];
  const existingIds = new Set(existingPending.map((item) => item._id));

  let mergedPending;

  if (state.search !== "") {
    if (state.currentPage === 1) {
      // For a fresh search, use the new data directly
      mergedPending = newData;
    } else {
      // Add only new, unique items
      const filteredNewData = newData.filter((item) => !existingIds.has(item._id));
      mergedPending = [...existingPending, ...filteredNewData];
    }
  } else {
    // For normal pagination, ensure uniqueness
    const filteredNewData = newData.filter((item) => !existingIds.has(item._id));
    mergedPending = [...existingPending, ...filteredNewData];
  }

  state.cardData.Pending = mergedPending;
  state.PendingTotal = totalCount;
});


    builder.addCase(getCardPendingList.rejected, (state) => {
      state.cardPendingStatus = "failed";
    });
    // assigned list

    builder.addCase(getCardAssignedList.pending, (state) => {
      state.cardAssignedStatus = "pending";
    });
    builder.addCase(getCardAssignedList.fulfilled, (state, action) => {
  state.cardAssignedStatus = "fulfilled";

  const newData = action.payload.data.data.data;
  const totalCount = action.payload.data.data.total_count;

  const existingItems = state.cardData?.Assigned || [];
  const existingIds = new Set(existingItems.map((item) => item._id));

  let mergedData;

  if (state.search !== "") {
    if (state.currentPage === 1) {
      mergedData = newData;
    } else {
      // Filter only new, unique items
      const filteredNewData = newData.filter((item) => !existingIds.has(item._id));
      mergedData = [...existingItems, ...filteredNewData];
    }
  } else {
    // For non-search case, always merge with uniqueness
    const filteredNewData = newData.filter((item) => !existingIds.has(item._id));
    mergedData = [...existingItems, ...filteredNewData];
  }

  state.cardData.Assigned = mergedData;
  state.AssignedTotal = totalCount;
});


    builder.addCase(getCardAssignedList.rejected, (state) => {
      state.cardAssignedStatus = "failed";
    });
  },
});

export const { updateConfig, resetConfig } = staffSlice.actions;

export default staffSlice.reducer;
